import React from 'react';

export const ClockIcon = () => (
  <svg role="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <title>Gepland</title>
    <path d="M14.5,8A6.5,6.5,0,1,1,8,1.5,6.5,6.5,0,0,1,14.5,8ZM12.14,8a.59.59,0,0,0-.59-.59h-3V3A.59.59,0,1,0,7.41,3V8A.59.59,0,0,0,8,8.59h3.55A.59.59,0,0,0,12.14,8Z" />
  </svg>
);
